import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={129.047}
      height={79.777}
      viewBox="0 0 129.047 79.777"
      {...props}
    >
      <g data-name="Group 696">
        <path
          data-name="Path 2241"
          d="M96.37 7.14a6.121 6.121 0 01-6.123-6.123h12.246A6.121 6.121 0 0196.37 7.14zm0 0"
          fill="#003586"
        />
        <path
          data-name="Path 2242"
          d="M90.461 14.283a2.039 2.039 0 11-.2-.01 1.254 1.254 0 01.2.01zm0 0"
          fill="#e6e9ed"
        />
        <path
          data-name="Path 2243"
          d="M102.514 14.273a2.033 2.033 0 11-.214.01 1.463 1.463 0 01.214-.01zm0 0"
          fill="#e6e9ed"
        />
        <path
          data-name="Path 2244"
          d="M128.027 31.632v4.082a5.1 5.1 0 11-10.2 0v-4.082zm0 0"
          fill="#ffd200"
        />
        <path
          data-name="Path 2245"
          d="M107.637 42.857h-.02a4.071 4.071 0 01-4.082-4.07v-3.074h8.164v3.074a4.073 4.073 0 01-4.062 4.07zm0 0"
          fill="#ffd200"
        />
        <path
          data-name="Path 2246"
          d="M92.309 54.095h8.164a4.082 4.082 0 01-8.164 0zm0 0"
          fill="#ccd1d9"
        />
        <path
          data-name="Path 2247"
          d="M102.738 52.136a13.093 13.093 0 006.919 1.959H83.124a13.089 13.089 0 006.918-1.959 13.225 13.225 0 006.349-11.307 13.225 13.225 0 006.347 11.307zm0 0"
          fill="#e6e9ed"
        />
        <path
          data-name="Path 2248"
          d="M85.135 42.857a4.071 4.071 0 01-4.052-4.07v-3.074h8.164v3.074h-.011a4.068 4.068 0 01-4.071 4.07zm0 0"
          fill="#ffd200"
        />
        <path
          data-name="Path 2249"
          d="M74.961 31.632v4.082h-.013a5.1 5.1 0 11-10.194 0v-4.082zm0 0"
          fill="#ffd200"
        />
        <path
          data-name="Path 2250"
          d="M96.373 8.164a7.153 7.153 0 01-7.144-7.144 1.021 1.021 0 112.041 0 5.1 5.1 0 1010.2 0 1.021 1.021 0 112.041 0 7.152 7.152 0 01-7.138 7.144zm0 0"
        />
        <path
          data-name="Path 2251"
          d="M83.125 55.114a14.3 14.3 0 01-14.288-14.287 1.02 1.02 0 112.041 0 12.247 12.247 0 0024.494 0 1.02 1.02 0 112.041 0 14.3 14.3 0 01-14.288 14.287zm0 0"
        />
        <path
          data-name="Path 2252"
          d="M90.055 53.159a1.02 1.02 0 01-.575-.178 12.272 12.272 0 01-5.36-10.142 1.02 1.02 0 112.041 0 10.231 10.231 0 004.469 8.455 1.021 1.021 0 01-.576 1.865zm0 0"
        />
        <path
          data-name="Path 2253"
          d="M96.373 41.847a1.02 1.02 0 01-1.02-1.021V7.12a1.02 1.02 0 112.041 0v33.706a1.019 1.019 0 01-1.021 1.021zm0 0"
        />
        <path
          data-name="Path 2254"
          d="M69.857 41.841a6.127 6.127 0 01-6.12-6.121 1.02 1.02 0 112.041 0 4.079 4.079 0 108.158 0 1.02 1.02 0 112.041 0 6.127 6.127 0 01-6.12 6.121zm0 0"
        />
        <path
          data-name="Path 2255"
          d="M74.959 36.74a1.019 1.019 0 01-1.02-1.019v-4.086a1.02 1.02 0 112.041 0v4.086a1.019 1.019 0 01-1.021 1.019zm0 0"
        />
        <path
          data-name="Path 2256"
          d="M64.754 36.74a1.019 1.019 0 01-1.02-1.019v-4.086a1.02 1.02 0 112.041 0v4.086a1.019 1.019 0 01-1.021 1.019zm0 0"
        />
        <path
          data-name="Path 2257"
          d="M74.959 32.654H64.754a1.021 1.021 0 010-2.041h10.2a1.021 1.021 0 010 2.041zm0 0"
        />
        <path
          data-name="Path 2258"
          d="M85.165 43.884a5.105 5.105 0 01-5.1-5.1 1.02 1.02 0 112.041 0 3.059 3.059 0 106.117 0 1.021 1.021 0 112.041 0 5.105 5.105 0 01-5.099 5.1zm0 0"
        />
        <path
          data-name="Path 2259"
          d="M89.246 39.804a1.019 1.019 0 01-1.02-1.021v-3.064a1.02 1.02 0 112.041 0v3.064a1.019 1.019 0 01-1.021 1.021zm0 0"
        />
        <path
          data-name="Path 2260"
          d="M81.084 39.804a1.02 1.02 0 01-1.02-1.021v-3.064a1.021 1.021 0 112.041 0v3.064a1.019 1.019 0 01-1.021 1.021zm0 0"
        />
        <path
          data-name="Path 2261"
          d="M89.248 36.74h-8.162a1.021 1.021 0 010-2.041h8.162a1.021 1.021 0 110 2.041zm0 0"
        />
        <path
          data-name="Path 2262"
          d="M109.658 55.114A14.3 14.3 0 0195.37 40.827a1.02 1.02 0 112.041 0 12.247 12.247 0 0024.494 0 1.02 1.02 0 112.041 0 14.3 14.3 0 01-14.288 14.287zm0 0"
        />
        <path
          data-name="Path 2263"
          d="M102.728 53.159a1.021 1.021 0 01-.576-1.865 10.231 10.231 0 004.469-8.455 1.02 1.02 0 112.041 0 12.274 12.274 0 01-5.36 10.142 1.02 1.02 0 01-.575.178zm0 0"
        />
        <path
          data-name="Path 2264"
          d="M122.926 41.841a6.127 6.127 0 01-6.12-6.121 1.02 1.02 0 112.041 0 4.079 4.079 0 108.158 0 1.02 1.02 0 112.041 0 6.127 6.127 0 01-6.12 6.121zm0 0"
        />
        <path
          data-name="Path 2265"
          d="M117.822 36.74a1.02 1.02 0 01-1.021-1.02v-4.086a1.02 1.02 0 112.041 0v4.087a1.019 1.019 0 01-1.02 1.019zm0 0"
        />
        <path
          data-name="Path 2266"
          d="M128.027 36.74a1.02 1.02 0 01-1.02-1.02v-4.086a1.02 1.02 0 112.041 0v4.087a1.019 1.019 0 01-1.021 1.019zm0 0"
        />
        <path
          data-name="Path 2267"
          d="M128.027 32.654h-10.2a1.021 1.021 0 110-2.041h10.2a1.021 1.021 0 110 2.041zm0 0"
        />
        <path
          data-name="Path 2268"
          d="M107.618 43.884a5.105 5.105 0 01-5.1-5.1 1.02 1.02 0 112.041 0 3.059 3.059 0 106.117 0 1.02 1.02 0 112.041 0 5.105 5.105 0 01-5.099 5.1zm0 0"
        />
        <path
          data-name="Path 2269"
          d="M103.535 39.804a1.02 1.02 0 01-1.02-1.021v-3.064a1.02 1.02 0 112.041 0v3.064a1.019 1.019 0 01-1.021 1.021zm0 0"
        />
        <path
          data-name="Path 2270"
          d="M111.697 39.804a1.019 1.019 0 01-1.02-1.021v-3.064a1.021 1.021 0 112.041 0v3.064a1.019 1.019 0 01-1.021 1.021zm0 0"
        />
        <path
          data-name="Path 2271"
          d="M111.7 36.74h-8.162a1.021 1.021 0 110-2.041h8.162a1.021 1.021 0 110 2.041zm0 0"
        />
        <path
          data-name="Path 2272"
          d="M109.657 55.117H83.124a1.021 1.021 0 010-2.041h26.533a1.021 1.021 0 010 2.041zm0 0"
        />
        <path
          data-name="Path 2273"
          d="M90.263 27.56a1.021 1.021 0 010-2.041 5.124 5.124 0 005.119-5.118 1.021 1.021 0 012.041 0 7.169 7.169 0 01-7.16 7.159zm0 0"
        />
        <path
          data-name="Path 2274"
          d="M96.403 21.437a1.019 1.019 0 01-1.02-1.021 5.124 5.124 0 00-5.119-5.118 1.021 1.021 0 010-2.041 7.168 7.168 0 017.16 7.159 1.02 1.02 0 01-1.021 1.021zm0 0"
        />
        <path
          data-name="Path 2275"
          d="M90.261 19.387a3.066 3.066 0 113.065-3.065 3.069 3.069 0 01-3.065 3.065zm0-4.09a1.024 1.024 0 101.024 1.024 1.025 1.025 0 00-1.024-1.024zm0 0"
        />
        <path
          data-name="Path 2276"
          d="M102.514 27.56a7.168 7.168 0 01-7.16-7.159 1.021 1.021 0 012.041 0 5.124 5.124 0 005.119 5.118 1.021 1.021 0 010 2.041zm0 0"
        />
        <path
          data-name="Path 2277"
          d="M96.375 21.437a1.02 1.02 0 01-1.02-1.021 7.168 7.168 0 017.16-7.159 1.021 1.021 0 010 2.041 5.124 5.124 0 00-5.119 5.118 1.019 1.019 0 01-1.021 1.021zm0 0"
        />
        <path
          data-name="Path 2278"
          d="M102.516 19.387a3.066 3.066 0 113.066-3.065 3.07 3.07 0 01-3.066 3.065zm0-4.09a1.024 1.024 0 101.024 1.024 1.025 1.025 0 00-1.024-1.024zm0 0"
        />
        <path
          data-name="Path 2279"
          d="M102.496 2.041H90.251a1.021 1.021 0 110-2.041h12.246a1.021 1.021 0 110 2.041zm0 0"
        />
        <path
          data-name="Path 2280"
          d="M96.388 59.193a5.108 5.108 0 01-5.1-5.1 1.02 1.02 0 112.041 0 3.062 3.062 0 006.123 0 1.021 1.021 0 112.041 0 5.108 5.108 0 01-5.105 5.1zm0 0"
        />
        <g data-name="Filled outline" transform="translate(0 29.641)">
          <path
            data-name="Path 1543"
            d="M.836.835v45.124h11.7V12.535h25.067v33.424h11.7V.835z"
            fill="#003586"
          />
          <ellipse
            data-name="Ellipse 33"
            cx={2.441}
            cy={2.563}
            rx={2.441}
            ry={2.563}
            transform="translate(22.516 4.307)"
            fill="#ffd200"
          />
          <circle
            data-name="Ellipse 34"
            cx={2.563}
            cy={2.563}
            transform="translate(31.79 4.307)"
            fill="#f4f4e6"
            r={2.563}
          />
          <ellipse
            data-name="Ellipse 35"
            cx={2.441}
            cy={2.563}
            rx={2.441}
            ry={2.563}
            transform="translate(40.821 4.307)"
            fill="#ffd200"
          />
          <ellipse
            data-name="Ellipse 36"
            cx={2.441}
            cy={2.319}
            rx={2.441}
            ry={2.319}
            transform="translate(40.821 12.849)"
            fill="#f4f4e6"
          />
          <circle
            data-name="Ellipse 37"
            cx={2.441}
            cy={2.441}
            transform="translate(40.821 21.148)"
            fill="#ffd200"
            r={2.441}
          />
          <ellipse
            data-name="Ellipse 38"
            cx={2.441}
            cy={2.563}
            rx={2.441}
            ry={2.563}
            transform="translate(40.821 29.446)"
            fill="#f4f4e6"
          />
          <ellipse
            data-name="Ellipse 39"
            cx={2.441}
            cy={2.563}
            rx={2.441}
            ry={2.563}
            transform="translate(40.821 37.745)"
            fill="#ffd200"
          />
          <ellipse
            data-name="Ellipse 40"
            cx={2.441}
            cy={2.563}
            rx={2.441}
            ry={2.563}
            transform="translate(13.729 4.307)"
            fill="#f4f4e6"
          />
          <ellipse
            data-name="Ellipse 41"
            cx={2.441}
            cy={2.563}
            rx={2.441}
            ry={2.563}
            transform="translate(4.21 4.307)"
            fill="#ffd200"
          />
          <ellipse
            data-name="Ellipse 42"
            cx={2.441}
            cy={2.319}
            rx={2.441}
            ry={2.319}
            transform="translate(4.21 12.849)"
            fill="#f4f4e6"
          />
          <circle
            data-name="Ellipse 43"
            cx={2.441}
            cy={2.441}
            transform="translate(4.21 21.148)"
            fill="#ffd200"
            r={2.441}
          />
          <ellipse
            data-name="Ellipse 44"
            cx={2.441}
            cy={2.563}
            rx={2.441}
            ry={2.563}
            transform="translate(4.21 29.446)"
            fill="#f4f4e6"
          />
          <ellipse
            data-name="Ellipse 45"
            cx={2.441}
            cy={2.563}
            rx={2.441}
            ry={2.563}
            transform="translate(4.21 37.745)"
            fill="#ffd200"
          />
          <path
            data-name="Path 1544"
            d="M12.534 12.534h25.069v33.425H12.534z"
            fill="rgba(80,180,248,0.45)"
          />
          <path
            data-name="Path 1545"
            d="M.836 45.959h48.466v3.342H.836z"
            fill="#003586"
          />
          <path
            data-name="Path 1546"
            d="M25.068 10.027a3.342 3.342 0 10-3.342-3.343 3.342 3.342 0 003.342 3.343zm0-5.014a1.671 1.671 0 11-1.671 1.671 1.671 1.671 0 011.671-1.671z"
          />
          <path
            data-name="Path 1547"
            d="M34.26 10.027a3.342 3.342 0 10-3.342-3.343 3.342 3.342 0 003.342 3.343zm0-5.014a1.671 1.671 0 11-1.671 1.671 1.671 1.671 0 011.671-1.671z"
          />
          <path
            data-name="Path 1548"
            d="M43.452 10.027a3.342 3.342 0 10-3.342-3.343 3.342 3.342 0 003.342 3.343zm0-5.014a1.671 1.671 0 11-1.671 1.671 1.671 1.671 0 011.671-1.671z"
          />
          <path
            data-name="Path 1549"
            d="M43.452 18.383a3.342 3.342 0 10-3.342-3.343 3.342 3.342 0 003.342 3.343zm0-5.014a1.671 1.671 0 11-1.671 1.671 1.671 1.671 0 011.671-1.671z"
          />
          <path
            data-name="Path 1550"
            d="M43.452 26.74a3.342 3.342 0 10-3.342-3.343 3.342 3.342 0 003.342 3.343zm0-5.014a1.671 1.671 0 11-1.671 1.671 1.671 1.671 0 011.671-1.671z"
          />
          <path
            data-name="Path 1551"
            d="M43.452 35.096a3.342 3.342 0 10-3.342-3.343 3.342 3.342 0 003.342 3.343zm0-5.014a1.671 1.671 0 11-1.671 1.671 1.671 1.671 0 011.671-1.671z"
          />
          <path
            data-name="Path 1552"
            d="M43.452 43.452a3.342 3.342 0 10-3.342-3.343 3.342 3.342 0 003.342 3.343zm0-5.014a1.671 1.671 0 11-1.671 1.671 1.671 1.671 0 011.671-1.671z"
          />
          <path
            data-name="Path 1553"
            d="M15.876 10.027a3.342 3.342 0 10-3.342-3.343 3.342 3.342 0 003.342 3.343zm0-5.014a1.671 1.671 0 11-1.671 1.671 1.671 1.671 0 011.671-1.671z"
          />
          <path
            data-name="Path 1554"
            d="M6.685 3.342a3.342 3.342 0 103.342 3.342 3.342 3.342 0 00-3.342-3.342zm0 5.014a1.671 1.671 0 111.671-1.671 1.671 1.671 0 01-1.671 1.671z"
          />
          <path
            data-name="Path 1555"
            d="M6.685 11.698a3.342 3.342 0 103.342 3.342 3.342 3.342 0 00-3.342-3.342zm0 5.014a1.671 1.671 0 111.671-1.671 1.671 1.671 0 01-1.671 1.671z"
          />
          <path
            data-name="Path 1556"
            d="M6.685 20.055a3.342 3.342 0 103.342 3.342 3.342 3.342 0 00-3.342-3.342zm0 5.014a1.671 1.671 0 111.671-1.671 1.671 1.671 0 01-1.671 1.671z"
          />
          <path
            data-name="Path 1557"
            d="M6.685 28.411a3.342 3.342 0 103.342 3.342 3.342 3.342 0 00-3.342-3.342zm0 5.014a1.671 1.671 0 111.671-1.671 1.671 1.671 0 01-1.671 1.671z"
          />
          <path
            data-name="Path 1558"
            d="M6.685 36.767a3.342 3.342 0 103.342 3.342 3.342 3.342 0 00-3.342-3.342zm0 5.014a1.671 1.671 0 111.671-1.671 1.671 1.671 0 01-1.671 1.671z"
          />
          <path
            data-name="Path 1559"
            d="M0 50.137h50.137V0H0zM1.671 1.671h46.795v43.453H38.438V11.7H11.7v33.424H1.671zm35.1 11.7v31.753H13.37V13.37zm-35.1 33.424h46.795v1.671H1.671z"
          />
          <path
            data-name="Path 1560"
            d="M15.281 23.641l4.178-4.178 1.182 1.181-4.178 4.179z"
          />
          <path
            data-name="Path 1561"
            d="M16.952 26.148l4.178-4.178 1.182 1.181-4.178 4.179z"
          />
          <path
            data-name="Path 1562"
            d="M33.424 22.562h1.671v-7.521h-5.013v1.671h3.342z"
          />
          <path
            data-name="Path 1563"
            d="M18.383 41.78h-1.671v-3.342h-1.671v5.014h3.342z"
          />
          <path data-name="Path 1564" d="M20.055 41.781h1.671v1.671h-1.671z" />
        </g>
      </g>
    </svg>
  )
}

export default SvgComponent
